import { useTokenList } from 'hooks/query/useTokenList';
import { FC } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { ProgramToken } from 'types';
import { BonusToken, DeploymentFormErrors } from '..';
import { IDeploymentForm } from '../type';
import SelectBonusTokens from './selectBonusTokens';
import SelectRewardToken from './selectRewardToken';
import SelectStakingToken from './selectStakingToken';

type Props = {
  setStakingToken: React.Dispatch<
    React.SetStateAction<ProgramToken | undefined>
  >;
  setRewardToken: React.Dispatch<
    React.SetStateAction<ProgramToken | undefined>
  >;
  rewardToken: ProgramToken | undefined;
  bonusTokens: BonusToken[];
  setBonusTokens: React.Dispatch<React.SetStateAction<BonusToken[]>>;
  register: UseFormRegister<IDeploymentForm>;
  errors: DeploymentFormErrors;
};

const SelectTokens: FC<Props> = ({
  setStakingToken,
  setRewardToken,
  rewardToken,
  bonusTokens,
  setBonusTokens,
  register,
  errors
}) => {
  const { data: tokenList } = useTokenList();

  return (
    <>
      <SelectStakingToken
        tokenList={tokenList || []}
        setStakingToken={setStakingToken}
      />
      <SelectRewardToken
        tokenList={tokenList || []}
        setRewardToken={setRewardToken}
        rewardToken={rewardToken}
        register={register}
        errors={errors}
      />
      <SelectBonusTokens
        tokenList={tokenList || []}
        bonusTokens={bonusTokens}
        setBonusTokens={setBonusTokens}
      />
    </>
  );
};

export default SelectTokens;
